angular.module('zc.zenclerkS')
  .controller('ZcsAgencyInvoicesListController', ZcsAgencyInvoicesListController);

ZcsAgencyInvoicesListController.$inject = ['agency', 'currencies', 'invoices'];
function ZcsAgencyInvoicesListController(agency, currencies, invoices) {
  let vm = this;
  vm.agency = agency;
  vm.thisMonth = moment().format('YYYY-MM');
  vm.invoices = invoices;
  vm.currencies = currencies;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/invoices/agency_invoices_list.controller.js